import { create } from 'zustand';

type Overlay = 'layers' | 'assets' | 'share' | 'tools' | 'actions' | 'selection' | 'search' | null;
function stored(key: string) {
  try {
    return localStorage.getItem(`sp.ui.${key}`) === 'true';
  } catch {
    return false;
  }
}
export const useEditorUI = create<{
  overlay: Overlay;
  multiSelect: boolean;
  interacting: boolean;
  layers: boolean;
  assets: boolean;
  open: (overlay: Overlay) => void;
  toggleMulti: () => void;
  togglePanel: (panel: 'layers' | 'assets') => void;
}>((set, get) => ({
  overlay: null,
  multiSelect: false,
  interacting: false,
  layers: stored('layers'),
  assets: stored('assets'),
  open: (overlay) => set({ overlay }),
  toggleMulti: () => set({ multiSelect: !get().multiSelect }),
  togglePanel: (panel) => {
    const next = !get()[panel];
    set({ [panel]: next });
    try {
      localStorage.setItem(`sp.ui.${panel}`, String(next));
    } catch {
      /* Preferences are optional. */
    }
  },
}));
